import { ENTITLEMENT_KEYS, FEATURE_ACCESS_POLICIES } from '../config/entitlements';

const FEATURE_GATE_DEFINITIONS = {
  [ENTITLEMENT_KEYS.BEST_BETS_FULL]: {
    previewLimit: 3,
    lockedOverlay: {
      title: 'Unlock All Bets',
      description: 'Subscribe to access all Best Bets and real-time updates.',
      ctaLabel: 'Start Free Trial',
      ctaTo: '/subscribe',
    },
  },
  [ENTITLEMENT_KEYS.PROMO_FINDER_FULL]: {
    banner: {
      message: 'Subscribe to unlock all Promo Finder opportunities.',
      ctaLabel: 'GO PRO',
      ctaTo: '/subscribe',
    },
  },
  [ENTITLEMENT_KEYS.ARBITRAGE_FULL]: {
    lockedOverlay: {
      title: 'Unlock All Games',
      description: 'Subscribe to unlock all betting opportunities.',
      ctaLabel: 'Subscribe Now',
      ctaTo: '/subscribe',
    },
  },
};

export function getFeatureGateDefinition(featureKey) {
  const policy = FEATURE_ACCESS_POLICIES[featureKey] || null;
  const definition = FEATURE_GATE_DEFINITIONS[featureKey] || null;

  if (!policy && !definition) {
    return null;
  }

  return {
    ...definition,
    policy,
  };
}

export function buildLockedOverlay(featureKey, overrides = {}) {
  const definition = getFeatureGateDefinition(featureKey);
  if (!definition?.lockedOverlay) {
    return null;
  }

  return {
    ...definition.lockedOverlay,
    ...overrides,
  };
}

export function buildGateBanner(featureKey, overrides = {}) {
  const definition = getFeatureGateDefinition(featureKey);
  if (!definition?.banner) {
    return null;
  }

  return {
    ...definition.banner,
    ...overrides,
  };
}

export function shouldLockPreviewItem({ accessState, index }) {
  const definition = getFeatureGateDefinition(accessState?.featureKey);
  const previewLimit = definition?.previewLimit;

  if (!accessState || accessState.allowed) {
    return false;
  }

  if (typeof previewLimit !== 'number') {
    return true;
  }

  return index >= previewLimit;
}